import React from 'react'
import ReactDOM from 'react-dom'
import L from 'leaflet'
import { MapControl } from 'react-leaflet'
import styles from './PoiTypePicker.scss'
import { poiIcons } from 'common/Map/Marker/poiIcons'

export class PoiTypePicker extends MapControl {
  createLeafletElement (props) {
    const { onTypeSelected } = props

    const icons = Object.values(poiIcons).map(
      icon => <PoiTypeIcon
        iconUrl={icon.iconUrl}
        key={icon.poiType}
        typeId={icon.poiType}
        onClick={() => onTypeSelected(icon.poiType)} />
    )

    const typePicker = L.control({ position: 'topleft' })
    const jsx = (
      <div className={styles.typePickerContainer} >
        {icons}
      </div>
    )

    typePicker.onAdd = map => {
      const container = L.DomUtil.create('div', '')
      ReactDOM.render(jsx, container)
      L.DomEvent.disableClickPropagation(container)
      return container
    }

    return typePicker
  }
}

class PoiTypeIcon extends React.PureComponent {
  render () {
    const { iconUrl, onClick } = this.props
    return (
      <img src={iconUrl} className={styles.icon} onClick={onClick} style={{ cursor: 'pointer' }} />
    )
  }
}
